import { ReactComponent as HomeIcon } from '@/assets/icons/home-icon.svg'
import { ReactComponent as ClockIcon } from '@/assets/icons/clock-icon.svg'
import { ReactComponent as ContactsIcon } from '@/assets/icons/contacts-icon.svg'
import { ReactComponent as BoxesIcon } from '@/assets/icons/boxes-icon.svg'
import './MenuBottom.scoped.sass'

import commonsService from '@/services/commons.service'
import writeMessageService from '@/app-domains/messages/writing/WritingModal.service'
import { useEffect, useState } from 'react'
import store from '@/core/store'
import classNames from 'classnames'

export function MenuBottom (props) {
  const [isHidden, setIsHidden] = useState(false)

  const isActiveClass = (path) => {
    if (path === 'home') return window.location.pathname === '/' ? 'active' : ''
    return window.location.pathname.includes(path) ? 'active' : ''
  }

  useEffect(() => {
    if (commonsService.isMobile()) {
      store.on('BOTTOM_MENU:HIDE', () => {
        setIsHidden(true)
      })
      store.on('BOTTOM_MENU:SHOW', () => {
        setIsHidden(false)
      })
    }
  }, [])

  return (
    <div className={`menu-bottom ${props.className || ''} ${isHidden ? 'bottom-mb-hide' : 'bottom-mb-show'}`}>
      <button type="button" className={`home-button ${isActiveClass('home')}`} onClick={() => commonsService.goToPage('/', true)}>
        <HomeIcon />
      </button>
      <button type="button" className={classNames('clock-button', isActiveClass('history'), {
        desktopHistory: !commonsService.isMobile(),
        mobileHistory: commonsService.isMobile()
      })} onClick={() => commonsService.goToPage('/history')}>
        <ClockIcon />
      </button>
      <button type="button" id='open-write-message-modal-button' className={classNames('write-button', {
        desktop: !commonsService.isMobile(),
        mobile: commonsService.isMobile()
      })} onClick={() => writeMessageService.open()}>
        <img src="/assets/icons/write-message-button.svg" />
      </button>
      <button type="button" className={classNames('contacts-button', isActiveClass('contacts'), {
        desktopContacts: !commonsService.isMobile(),
        mobileContacts: commonsService.isMobile()
      })} disabled={false} onClick={() => commonsService.goToPage('/contacts')}>
        <ContactsIcon />
      </button>
      <button type="button" className={classNames('boxes-button', isActiveClass('boxes'), {
        desktopBoxes: !commonsService.isMobile(),
        mobileBoxes: commonsService.isMobile()
      })} onClick={() => commonsService.goToPage('/boxes')}>
        <BoxesIcon />
      </button>
    </div>
  )
}
